export default "__VITE_ASSET__ejLr1AVe__"